<template>
  <div class="container">
    <div class="bar">
      <div class="red" :style="{width: redWidth + '%'}"></div>
      <div class="yellow" :style="{width: yellowWidth + '%'}"></div>
      <div class="green" :style="{width: greenWidth + '%'}"></div>
      <div class="gray" :style="{width: grayWidth + '%'}"></div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    count: {
      type: Number,
      default: 0,
    },
    red: {
      type: Number,
      default: 0,
    },
    green: {
      type: Number,
      default: 0,
    },
    yellow: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    /** Total questions in the category; R/Y/G widths are shares of this, gray is the unanswered remainder. */
    segmentTotal() {
      return this.count > 0 ? this.count : 1;
    },
    greenWidth() {
      return (this.green / this.segmentTotal) * 100;
    },
    yellowWidth() {
      return (this.yellow / this.segmentTotal) * 100;
    },
    redWidth() {
      return (this.red / this.segmentTotal) * 100;
    },
    grayWidth() {
      return 100 - (this.greenWidth + this.yellowWidth + this.redWidth);
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.bar {
  width: 100%;
  height: 6px;
  display: flex;
  border-radius: var(--radius-xs, 4px);
  overflow: hidden;
}

.green {
  background-color: #00b46d;
}

.yellow {
  background-color: #ffd83e;
}

.red {
  background-color: #dc3416;
}

.gray {
  background-color: rgba(153, 164, 174, 0.2);
}
</style>
